import { format, intervalToDuration, parseISO } from 'date-fns';

import { ExpiryTimeLeft } from 'src/features/room/components/active-machine-info/active-machine-info.types';

export const calculateExpiryTimeLeft = (start: Date, end: Date): ExpiryTimeLeft => {
  const duration = intervalToDuration({
    start,
    end,
  });

  return { hours: duration.hours ?? 0, minutes: duration.minutes ?? 0, seconds: duration.seconds ?? 0 };
};

export const formatDate = (dateString: string | undefined) => {
  if (!dateString) return '';
  const date = parseISO(dateString);
  return format(date, 'dd MMM');
};

export const formatFullDate = (dateString: string | undefined) => {
  if (!dateString) return '';
  const date = parseISO(dateString);
  return format(date, 'd MMMM yyyy');
};

export function formatTimeUntil(date: Date) {
  const now = new Date();
  const diffMs = date.getTime() - now.getTime();

  if (diffMs <= 0) return { period: 'minutes', text: 'Ended' };

  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);

  console.log(diffSeconds, diffMinutes);

  if (diffMinutes < 1 && diffSeconds < 60) {
    return {
      period: 'seconds',
      text: `${diffSeconds} second${diffSeconds === 1 ? '' : 's'}`,
    };
  }

  if (diffMinutes < 60) {
    return {
      period: 'minutes',
      text: `${diffMinutes} minute${diffMinutes === 1 ? '' : 's'}`,
    };
  }

  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  if (diffHours < 24) {
    return {
      period: 'hours',
      text: `${diffHours} hour${diffHours === 1 ? '' : 's'}`,
    };
  }

  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  return {
    period: 'days',
    text: `${diffDays} day${diffDays === 1 ? '' : 's'}`,
  };
}
